import { render } from "./UsersChart.vue?vue&type=template&id=65ba8089"
import script from "./UsersChart.vue?vue&type=script&lang=js"
export * from "./UsersChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__